import pImg1 from '../images/testimonial/sa-tes01.jpg'
import pImg2 from '../images/testimonial/sa-tes02.jpg'
import pImg3 from '../images/testimonial/sa-tes03.jpg'
import pImg4 from '../images/testimonial/sa-tes04.jpg'
import pImg5 from '../images/project/img01.png'
import pImg6 from '../images/project/img02.png'
import pImg7 from '../images/project/img03.png'



import icon1 from '../images/icon/pro-icon01.png'
import icon2 from '../images/icon/pro-icon02.png'
import icon3 from '../images/icon/pro-icon03.png'


const Project = [
    {
        Id: '1',
        pImg: pImg1,
        title: 'Sitemarks success with tailored SEO solutions',
        slug: 'Sitemarks-success-with-tailored-SEO-solutions',
        rnumber: '315',
        rtext: 'ROI increase over 3 years',
        tnumber: '218',
        ttext: 'In value due to increased team productivity',
        snumber: '522',
        stext: 'Saved due to reduced administration time',
        description: 'Sitemark thrived with customized SEO strategies, enhancing visibility and organic traffic for strong ROI.',
    },
    {
        Id: '2',
        pImg: pImg2,
        title: 'How greenish achieved a eco-friendly SEO success',
        slug: 'How-greenish-achieved-a-eco-friendly-SEO-success',
        rnumber: '310',
        rtext: 'ROI increase over 3 years',
        tnumber: '121',
        ttext: 'In value due to increased team productivity',
        snumber: '410',
        stext: 'Saved due to reduced administration time',
        description: 'Our experienced coaches are not just educators; they are partners in your journey..',
    },
    {
        Id: '3',
        pImg: pImg3,
        title: 'Expanding cambridges reach with SEO solutions',
        slug: 'Expanding-cambridges-reach-with-SEO-solutions',
        rnumber: '418',
        rtext: 'ROI increase over 3 years',
        tnumber: '185',
        ttext: 'In value due to increased team productivity',
        snumber: '480',
        stext: 'Saved due to reduced administration time',
        description: 'Cambridge expanded its reach with through targeted SEO solutions, boosting visibility and driving growth.',
    },
    {
        Id: '4',
        pImg: pImg4,
        title: 'Madrids digital footprint with targeted SEO',
        slug: 'Madrids-digital-footprint-with-targeted-SEO',
        rnumber: '588',
        rtext: 'ROI increase over 3 years',
        tnumber: '355',
        ttext: 'In value due to increased team productivity',
        snumber: '547',
        stext: 'Saved due to reduced administration time',
        description: 'Targeted SEO strategies strengthened Madrids digital footprint,visibility and driving engagement.',
    },
    {
        Id: '5',
        pImg: pImg5,
        icon:icon1,
        title: 'Delivering remote solutions',
        slug: 'Delivering-remote-solutions',
        rtext1: 'product design',
        rtext2: 'logo',
        rtext3: 'visual identity',
        description: 'Delivering Remote Solutions provides teams with tools for effective and productivity from anywhere.',
    },
    {
        Id: '6',
        pImg: pImg6,
        icon:icon2,
        title: 'Real-time health monitoring..',
        slug: 'Real-time-health-monitoring',
        rtext1: 'product design',
        rtext2: 'App',
        rtext3: 'visual identity',
        description: 'Real-Time Health Monitoring via Mobile App tracks logo vital signs, enabling early detection.',
    },
    {
        Id: '7',
        pImg: pImg7,
        icon:icon3,
        title: 'Simple time management..',
        slug: 'Simple-time-management',
        rtext1: 'product design',
        rtext2: '3d',
        rtext3: 'visual identity',
        description: 'Simple Time Management boosts productivity by prioritizing tasks and reducing distractions.',
    },
    {
        Id: '8',
        pImg: pImg6,
        icon:icon2,
        title: 'Real-time health monitoring..',
        slug: 'Real-time-health-monitoring',
        rtext1: 'product design',
        rtext2: 'App',
        rtext3: 'visual identity',
        description: 'Real-Time Health Monitoring via Mobile App tracks logo vital signs, enabling early detection.',
    },
    {
        Id: '9',
        pImg: pImg6,
        icon:icon2,
        title: 'Real-time health monitoring..',
        slug: 'Real-time-health-monitoring',
        rtext1: 'product design',
        rtext2: 'App',
        rtext3: 'visual identity',
        description: 'Real-Time Health Monitoring via Mobile App tracks logo vital signs, enabling early detection.',
    },

]

export default Project;